var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 633.25 205.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#23c99d;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -80.17,
    y1: 183.2,
    x2: 519.39,
    y2: -57.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00004d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01044f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#082d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0e526e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#14727b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#198e85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1ca48e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1fb595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#21c09a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#23c79c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23c99d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.76,21.6V202.12H122.54l-.6-17L116.8,38.63l-.6-17Zm65.61,23.48L182.6,43.21V204.05l48.16,1.69ZM103.65,0,0,3.62,7.06,205.74l103.65-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.76,149.74h-6.93v-2.51h16.73v2.51h-6.94v17.71h-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M336.19,167.45l-4.36-6.21c-.54,0-1,.06-1.27.06h-5v6.15h-2.89V147.23h7.89a9.31,9.31,0,0,1,6.18,1.88,6.36,6.36,0,0,1,2.25,5.17,6.73,6.73,0,0,1-1.15,4,6.51,6.51,0,0,1-3.3,2.4l4.8,6.79Zm-1.53-9.79a4.13,4.13,0,0,0,1.44-3.38,4.09,4.09,0,0,0-1.44-3.37,6.52,6.52,0,0,0-4.19-1.17h-4.91v9.1h4.91A6.46,6.46,0,0,0,334.66,157.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.52,162.4H367.77l-2.22,5h-3l9.16-20.22h2.86l9.19,20.22h-3Zm-1-2.31-4.36-9.92-4.37,9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408.74,147.23h8.53A12.29,12.29,0,0,1,423,148.5a9.39,9.39,0,0,1,3.86,3.57,10.82,10.82,0,0,1,0,10.54,9.39,9.39,0,0,1-3.86,3.57,12.29,12.29,0,0,1-5.69,1.27h-8.53Zm8.35,17.71a9.42,9.42,0,0,0,4.32-.95,6.91,6.91,0,0,0,2.88-2.68,8.31,8.31,0,0,0,0-7.94,6.91,6.91,0,0,0-2.88-2.68,9.42,9.42,0,0,0-4.32-.95h-5.46v15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.25,164.94v2.51H454.57V147.23h14.27v2.51H457.46V156H467.6v2.46H457.46v6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543,147.23v20.22h-2.89v-9H528.51v9h-2.89V147.23h2.89v8.69h11.62v-8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M573.12,165.37q-2.25-2.31-2.25-6.64v-11.5h2.89v11.38q0,6.51,5.69,6.5a5.48,5.48,0,0,0,4.25-1.6,7.05,7.05,0,0,0,1.47-4.9V147.23H588v11.5c0,2.91-.76,5.13-2.26,6.66a9.78,9.78,0,0,1-12.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M632.24,158.74a5.07,5.07,0,0,1,1,3.25,4.68,4.68,0,0,1-2,4,9.87,9.87,0,0,1-5.76,1.41h-9.65V147.23h9.07a9,9,0,0,1,5.36,1.38,4.52,4.52,0,0,1,1.89,3.85,5,5,0,0,1-.73,2.74,4.75,4.75,0,0,1-2,1.76A5.18,5.18,0,0,1,632.24,158.74Zm-13.49-9.17V156h5.92a6,6,0,0,0,3.43-.82,3,3,0,0,0,0-4.83,6,6,0,0,0-3.43-.82Zm10.34,14.73a2.8,2.8,0,0,0,1.24-2.54c0-2.25-1.64-3.38-4.94-3.38h-6.64v6.73h6.64A6.84,6.84,0,0,0,629.09,164.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.48,125.47a23.53,23.53,0,0,1-9.17-8.83,25.37,25.37,0,0,1,0-25.13,23.53,23.53,0,0,1,9.17-8.83,28.41,28.41,0,0,1,26.16,0,23.42,23.42,0,0,1,9.14,8.79,25.72,25.72,0,0,1,0,25.21,23.42,23.42,0,0,1-9.14,8.79,28.41,28.41,0,0,1-26.16,0Zm22.63-5.32a17.81,17.81,0,0,0,6.66-6.63,19.5,19.5,0,0,0,0-18.89A17.81,17.81,0,0,0,310.11,88a18.94,18.94,0,0,0-9.52-2.4A19.33,19.33,0,0,0,291,88a17.64,17.64,0,0,0-6.73,6.63,19.57,19.57,0,0,0,0,18.89,17.64,17.64,0,0,0,6.73,6.63,19.33,19.33,0,0,0,9.58,2.4A18.94,18.94,0,0,0,310.11,120.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.9,84.5q5.36,4.47,5.36,12.3t-5.36,12.29q-5.36,4.47-14.7,4.46H350.32v14.56h-6.87V80H362.2Q371.55,80,376.9,84.5ZM372,104.8c2.29-1.86,3.44-4.52,3.44-8s-1.15-6.15-3.44-8S366.34,86,362,86H350.32v21.57H362Q368.52,107.58,372,104.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M407.25,86H390.77V80h39.77v6H414.05v42.1h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M444.89,79.49h6.87v49.17h-6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M481.63,125.47a23.6,23.6,0,0,1-9.17-8.83,25.37,25.37,0,0,1,0-25.13,23.6,23.6,0,0,1,9.17-8.83,28.43,28.43,0,0,1,26.17,0,23.4,23.4,0,0,1,9.13,8.79,25.72,25.72,0,0,1,0,25.21,23.4,23.4,0,0,1-9.13,8.79,28.43,28.43,0,0,1-26.17,0Zm22.63-5.32a17.66,17.66,0,0,0,6.66-6.63,19.5,19.5,0,0,0,0-18.89A17.66,17.66,0,0,0,504.26,88a18.88,18.88,0,0,0-9.51-2.4,19.27,19.27,0,0,0-9.58,2.4,17.57,17.57,0,0,0-6.73,6.63,19.5,19.5,0,0,0,0,18.89,17.57,17.57,0,0,0,6.73,6.63,19.27,19.27,0,0,0,9.58,2.4A18.88,18.88,0,0,0,504.26,120.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M579,80v48.07h-5.63L544.47,92.26v35.85h-6.86V80h5.63l28.84,35.85V80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M603.78,127a21.49,21.49,0,0,1-7.93-4.36l2.54-5.36a21,21,0,0,0,7,4,25.85,25.85,0,0,0,8.82,1.55c4,0,7-.68,8.93-2a6.24,6.24,0,0,0,3-5.39,5.3,5.3,0,0,0-1.61-4,10.82,10.82,0,0,0-4-2.37q-2.37-.83-6.7-1.85a68.9,68.9,0,0,1-8.76-2.61,14.48,14.48,0,0,1-5.7-4A10.74,10.74,0,0,1,597,93.22a12.37,12.37,0,0,1,2-6.93,13.94,13.94,0,0,1,6.15-5,25,25,0,0,1,10.23-1.85,32.51,32.51,0,0,1,8.38,1.1,22.06,22.06,0,0,1,7.07,3.16l-2.26,5.49a25.24,25.24,0,0,0-6.46-2.92,24.22,24.22,0,0,0-6.73-1q-5.83,0-8.76,2.12a6.54,6.54,0,0,0-2.91,5.5,5.25,5.25,0,0,0,1.64,4,11.38,11.38,0,0,0,4.09,2.4,64.08,64.08,0,0,0,6.63,1.82,67.54,67.54,0,0,1,8.72,2.61,14.74,14.74,0,0,1,5.67,4,10.51,10.51,0,0,1,2.37,7.22,12.33,12.33,0,0,1-2.06,6.9,13.84,13.84,0,0,1-6.25,4.94,25.78,25.78,0,0,1-10.31,1.82A32.94,32.94,0,0,1,603.78,127Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.7880809fe52564c2e65216e0f86c7a47.svg";
export { ForwardRef as ReactComponent };